import { getAccountTradeId } from '../config';

export const getDataFromLocalstorage = () => {
  const fromStorage = localStorage.getItem('symbols.trading.data');
  let data = JSON.parse(fromStorage) ?? [];
  return data;
};

export const getMenuFromLocalstorage = () => {
  try {
    const accountId = getAccountTradeId();
    const fromStorage = localStorage.getItem('symbol_menu_list') || window.electron?.store.get('symbol_menu_list');
    
    if (!fromStorage) {
      const dataJson = {
        [accountId]: {
          menu: [],
          active: ''
        }
      };
      localStorage.setItem('symbol_menu_list', JSON.stringify(dataJson));
      window.electron?.store.set('symbol_menu_list', JSON.stringify(dataJson));
      return dataJson;
    }

    const parsedData = JSON.parse(fromStorage);
    
    // Check if account exists and has valid menu data
    if (!parsedData[accountId] || !Array.isArray(parsedData[accountId].menu)) {
      const dataJson = {
        [accountId]: {
          menu: [],
          active: ''
        }
      };
      localStorage.setItem('symbol_menu_list', JSON.stringify(dataJson));
      window.electron?.store.set('symbol_menu_list', JSON.stringify(dataJson));
      return dataJson;
    }

    const { menu, active } = parsedData[accountId];
    return { menu, active, accountId };
  } catch (e) {
    console.error('Error in getMenuFromLocalstorage:', e);
    // Return default structure in case of any error
    return {
      menu: [],
      active: ''
    };
  }
};
